export default "__VITE_ASSET__fb41d348__"